import React, { Component } from 'react';

import { PortraitModalComponent } from 'styled_components/Common/PortraitModalComponent';
import { TicketApi } from 'services/ticket';
import { RESOLUTIONS } from 'services/config';
import { ModalHeader } from 'styled_components/Common/ModalHeader';
import { HelpBody } from 'sub_components/Support/HelpBody';
import { ModalFooter } from 'styled_components/Common/ModalFooter';
import { CogSVG } from 'styled_components/SVG/CogSVG';

class HelpModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			description: '',
			email: '',
			success: false,
			error: null,
		};
	}

	formatDescription = (des, email) => {
		let description = '';
		description += `Login Issue - HIGH PRIORITY:\n `;
		description += `Ticket: Login Trouble\n `;
		description += `Email: ${email}\n `;
		description += `Description: ${des}\n `;

		return description;
	};

	onChange = event => {
		this.setState({ [event.target.name]: event.target.value });
	};

	onClick = async () => {
		const { email, description } = this.state;

		TicketApi.sendSlackMessage({ description: this.formatDescription(description, email) })
			.then(response => {
				if (response.status === 200 && response.data.success && !response.data.error) {
					this.setState({ success: true, error: null, email: '', description: '' });
				} else {
					this.setState({ success: false, error: 'Something went wrong. Please try again later.' });
				}
			})
			.catch(error => {
				this.setState({ success: false, error });
			});
	};

	getSize = breakpoint => {
		let size = 'large';
		if (breakpoint === RESOLUTIONS.MED) {
			size = 'medium';
		} else if (breakpoint === RESOLUTIONS.HIGH) {
			size = 'medium';
		}

		return size;
	};

	render() {
		const { success, error, email, description } = this.state;
		const { isOpen, breakpoint, area, navigate, toggleOpen } = this.props;
		return (
			<div className='help-modal-wrapper'>
				<PortraitModalComponent
					closeModal={toggleOpen}
					show={isOpen}
					header={
						<ModalHeader
							image={<CogSVG id='special-id-2' />}
							svg={true}
							text={''}
							className='forgot-password'
						/>
					}
					title={area === 'portal' ? 'Experiencing an issue ?' : 'Experiencing a login issue ? '}
					subTitle={area === 'portal' ? 'See support options below.' : `Follow the steps below.`}
					size={this.getSize(breakpoint)}
					breakpoint={breakpoint}
				>
					<HelpBody
						onChange={this.onChange}
						success={success}
						error={error}
						email={email}
						description={description}
						area={area}
						navigate={navigate}
						toggleOpen={toggleOpen}
					/>
					<div className='reset-button'>
						<ModalFooter
							cypressId='footer'
							id='forgot-password'
							buttonText1='SUBMIT'
							buttonText2=''
							buttonActive1={email.match(/^[^@]+@[^@]+.[^@]+$/) && description && !success}
							module='support'
							buttonFunction1={area === 'portal' ? null : !success && this.onClick}
							size={this.getSize(breakpoint)}
						/>
					</div>
				</PortraitModalComponent>
			</div>
		);
	}
}
export default HelpModal;
